<template>
  <SampleEditImages />
</template>

<script>
import SampleEditImages from "@/components/samples/SampleEditImages";
export default {
  name: "Images",
  components: { SampleEditImages }
};
</script>
